// 権限関連の型定義
export type Role = 'account_mgr' | 'info_mgr' | 'office' | 'issuer_mgr' | 'issuer' | 'system' | 'unassigned';

export interface PermissionConfig {
  roles: Role[];
  divisions?: string[]; // 特定の組織のみアクセス可能な場合
}

// 各画面のアクセス権限マッピング
export const ROUTE_PERMISSIONS: Record<string, PermissionConfig> = {
  // 共通画面
  '/dashboard': { roles: ['account_mgr', 'info_mgr', 'office', 'issuer_mgr', 'issuer', 'system'] },
  '/notifications': { roles: ['account_mgr', 'info_mgr', 'office', 'issuer_mgr', 'issuer', 'system'] },

  // OPAM管理者向け
  '/admin/announcements': { roles: ['system'] },
  '/admin/issue-tasks': { roles: ['system', 'issuer', 'office'] },
  '/admin/allocation-list': { roles: ['system', 'issuer', 'office'] },
  '/admin/inventory-progress': { roles: ['system'] },

  // 発行管理責任者向け
  '/issuer/approvals': { roles: ['issuer_mgr'] },
  '/issuer/approvals/[id]': { roles: ['issuer_mgr'] },

  // 情報管理責任者向け
  '/info-manager/approvals': { roles: ['info_mgr'] },
  '/info-manager/approvals/[id]': { roles: ['info_mgr'] },

  // 事務局向け（officeにもissuerの権限を付与）
  '/office/allocation-list': { roles: ['office', 'issuer', 'system'] },
  '/office/allocation-detail/[id]': { roles: ['office', 'issuer', 'system'] },
  '/office/review-list': { roles: ['office', 'system'] },
  '/office/allocation-detail': { roles: ['office', 'issuer', 'system'] },

  // アカウント管理責任者向け
  '/submissions': { roles: ['account_mgr'] },
  '/submissions/[id]': { roles: ['account_mgr'] },
  '/submissions/new': { roles: ['account_mgr'] },
  '/organization': { roles: ['account_mgr'] },
  '/inventory': { roles: ['account_mgr'] },
  '/inventory/detail': { roles: ['account_mgr'] },
  '/office/inventory': { roles: ['office'] },
  '/office/inventory/detail': { roles: ['office'] },
  '/users': { roles: ['account_mgr'] },
  '/users/[id]': { roles: ['account_mgr'] },
};

// ユーザー情報の型定義
export interface UserInfo {
  id: string;
  upn: string;
  role: Role;
  name: string;
  email: string;
  division?: {
    id: string;
    name: string;
    code: string;
  };
  position: string;
  created_at: string;
  updated_at: string;
}

// ロールの表示名マッピング
export const ROLE_DISPLAY_NAMES: Record<Role, string> = {
  account_mgr: 'アカウント管理責任者',
  info_mgr: '情報管理責任者',
  office: '事務局',
  issuer_mgr: '発行管理責任者',
  issuer: '発行作業者',
  system: 'システム管理者',
  unassigned: '未割り当て',
};
